// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['sl_SI']  = {
  "name": "sl_SI",
  "day": {
    "abbrev": [
      "ned",
      "pon",
      "tor",
      "sre",
      "čet",
      "pet",
      "sob"
    ],
    "full": [
      "nedelja",
      "ponedeljek",
      "torek",
      "sreda",
      "četrtek",
      "petek",
      "sobota"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "feb",
      "mar",
      "apr",
      "maj",
      "jun",
      "jul",
      "avg",
      "sep",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "januar",
      "februar",
      "marec",
      "april",
      "maj",
      "junij",
      "julij",
      "avgust",
      "september",
      "oktober",
      "november",
      "december"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d. %m. %Y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

